export default __webpack_public_path__ + "static/media/nerf-strelba.7b8cee4c.svg";